import { useState, useCallback, useMemo } from 'react';
import { useAuth } from '../../../../utils/Auth';
import { useFileUpload } from '../../../../utils/hooks/useFileUpload';
import { motion } from 'motion/react';
import { disabledVariants, logoVariants, transition } from '../variants';
import styles from './Logo.module.css';

const acceptableFileTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'];

export default function Logo() {
    const { fileHandler, qr_data, dataDispatch, qr_options, optionsDispatch } = useAuth();
    const { setLogo, files, setFiles } = fileHandler;
    const { handleFileSelected } = useFileUpload({ type: '', acceptableFileTypes, fileHandleType: 'logo' })

    const [ fileName, setFileName ] = useState('');
    const [ error, setError ] = useState('');

    const handleLogo = async (e) => {
        const file = e.target.files[0];
        if (file) {
            setFileName(file.name);
            await handleFileSelected(e.target.files);
        }
    };

    const handleRemoveLogo = useCallback(() => {
        setError('');
        setFileName('');
        const pathsToLogoFiles = qr_data.data?.logo_files?.length > 0 && qr_data.data?.logo_files.map(f => f?.path || '').filter(f => f !== '');

        if (pathsToLogoFiles.length > 0) {
            setFiles(prev => ({ ...prev, deleteFiles: [ ...prev.deleteFiles, ...qr_data?.data?.logo_files.map(f => f.path)]}));
        };

        if (qr_options.image && qr_options.image.includes(`${qr_data.id}/logo.png`)) {
            const path = `qr_logos/${qr_data.id}/logo.png`;
            if (!files.deleteFiles.includes(path)) {
                setFiles(prev => ({ ...prev, deleteFiles: [ ...prev.deleteFiles, path ]}));
            };
        };

        if (files.hasOwnProperty('logo')) {
            delete files.logo
        };

        dataDispatch({ type: 'logo_files', data: [] });
        optionsDispatch({ type: 'remove-logo', options: '' });

        const input = document.getElementById('logoUpload');
        if (input) {
            input.value = ''
        }
    }, [qr_data.id, files?.deleteFiles, setFiles, setLogo, qr_options.image, optionsDispatch]);

    const displayMessage = useMemo(() => {
        if (fileName) {
            return <div className={styles.chosen}>File Chosen: <span>{fileName}</span></div>;
        };
        if (error) {
            return <div className={styles.error}>{error}</div>;
        };
        return null;
    },[fileName, error]);

    return (
        <div className={styles.container}>
            <div className={styles.label}>Upload</div>
            <div className={styles.inputGroup}>
                <motion.label 
                    htmlFor='logoUpload' 
                    className={styles.uploadBtn}
                    transition={transition}
                    variants={logoVariants}
                    initial={false}
                    animate={files.logo ? 'yesLogo' : 'noLogo'}
                >
                    <input
                        id='logoUpload'
                        type='file'
                        className={styles.fileInput}
                        onChange={handleLogo}
                        accept={acceptableFileTypes.join(', ')}
                    />
                    <i className='far fa-upload' />
                    (png, jpeg, jpg, webp)
                    {displayMessage}
                </motion.label>
                <motion.button
                    className={styles.removeBtn} 
                    onClick={handleRemoveLogo}
                    transition={transition}
                    variants={disabledVariants}
                    initial={false}
                    animate={files.logo ? 'enabled' : 'disabled'}
                    disabled={!files.logo}
                >
                    <i className='far fa-trash-can' />
                    <span>Remove</span>
                </motion.button>
            </div>
        </div>
    );
};
